const ScrollIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      aria-hidden='true'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 40 40'
      className={className}
    >
      <path
        d='M31.667 15c0-6.443-5.224-11.667-11.667-11.667S8.334 8.557 8.334 15v10c0 6.443 5.223 11.667 11.666 11.667 6.444 0 11.667-5.224 11.667-11.667V15ZM20 10v6.667'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
export default ScrollIcon;
